export {
  RENDERER_TYPE,
  htmlRenderer,
} from './htmlRenderer';
